<div
  class="menu-wrapper menu-wrapper-animation"
>
  <div
    fxLayout="column"
    fxLayout.gt-sm="row"
    fxLayoutAlign="start start"
    fxLayoutAlign.gt-sm="space-between center"
    class="menu-container menu-container-animation"
  >
    <div
      fxLayout="row"
      fxLayoutAlign="space-between center"
      class="menu-header menu-header-animation"
    >
      <a
        [routerLink]="[basePath]"
        class="logo-container logo-container-animation"
      >
        <img
          [src]="agencyService.agency.logo.url ? agencyService.agency.logo.url : '/assets/icons/logo.svg'"
          [alt]="agencyService.agency.name"
          class="logo logo-animation"
          loading="lazy"
        >
      </a>
      <button
        class="main-menu-burger"
        fxHide.gt-sm
        [class.open]="open"
        (click)="toggleMobileMenu()"
      >
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>
    <div
      fxLayout="column"
      fxLayout.gt-sm="row"
      fxLayoutAlign="start start"
      fxLayoutAlign.gt-sm="space-between center"
      class="menu-items-container menu-items-container-animation"
      [class.open]="open"
    >
      <nav
        fxLayout="column"
        fxLayout.gt-sm="row"
        fxLayoutAlign="start start"
        fxLayoutAlign.gt-sm="center center"
        class="menu-items-wrapper menu-items-wrapper-animation"
      >
        <div
          *ngFor="let item of links"
          class="menu-item-wrapper menu-item-wrapper-animation"
        >
          <app-menu-item-base
            [item]="item"
            [children]="item.children"
            [currentRoute]="currentRoute"
            (toggleMobileMenu)="toggleMobileMenu()"
          >
          </app-menu-item-base>
        </div>
        <div class="menu-item-wrapper menu-item-wrapper-animation">
          <a
            class="menu-item menu-item-animation"
            fxlayout="column"
            fxlayoutalign="center start"
            fxlayoutalign.gt-sm="center center"
            routerlinkactive="active"
            href="https://blog.dream-residence.ro/"
            target="_blank"
            style="flex-direction: column; box-sizing: border-box; display: flex; max-width: 100%; place-content: center; align-items: center;"
          >
            <div class="menu-item-text menu-item-text-animation">
              <span>
                blog
              </span>
            </div>
          </a>
        </div>
      </nav>
      <a
        *ngIf="hasPhoneNumber"
        fxHide
        fxShow.gt-sm
        fxLayout="row"
        fxLayoutAlign="center center"
        [href]="'tel:' + agencyService.agency.phone"
        class="contact-phone-container contact-phone-container-animation"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="phone_click"
        appFbqEvent="Contact"
        [customData]="{content_name: 'phone_click', content_category: 'click'}"
      >
        <img
          src="/assets/icons/contact/phone_main.svg"
          alt=""
          class="phone-icon phone-icon-animation"
        >
        <span
          class="phone-number phone-number-animation"
        >
          {{ agencyService.agency.phone | beautify }}
        </span>
      </a>
      <a
        fxHide
        fxShow.gt-sm
        fxLayout="row"
        fxLayoutAlign="center center"
        [href]="'mailto:' + agencyService.agency.email"
        class="contact-phone-container contact-phone-container-animation"
        appGtagEvent
        eventCategory="contact"
        eventAction="click"
        eventLabel="email_click"
        appFbqEvent="Contact"
        [customData]="{content_name: 'email_click', content_category: 'click'}"
      >
        <img
          src="/assets/icons/contact/email.svg"
          alt=""
          class="email-icon phone-icon-animation"
        >
      </a>
      <ng-template
        [ngIf]="agencyService.agency.social_header_visibility === true && hasSocialLinks"
      >
        <app-social-icons-base
          [isTooltipBelow]="true"
        >
        </app-social-icons-base>
      </ng-template>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/shared/menu-container/menu-container.component.html